module.exports = __webpack_public_path__ + "static/media/download-csv.9840bdb4.svg";